import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/News/Preiscrizioni.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Spa from "../Spa";
import SpaceL from "../../commons/SpaceL";
import prezzi from "../../images/News/Listino_2025_26.png";
import zumba from "../../images/News/Zumba.jpg";


function Preiscrizioni_Nuoto () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{""}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <img src={locandina} style={{width: "100%"}}></img>
                <SpaceL />
                <div style={{fontSize: "18px"}}>
                    Scarica il listino prezzi
                    <a style={{alignSelf: "end", marginLeft: "2em"}} href={prezzi} download>
                        <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                    </a>
                </div>
            </div>
            <Space />

        </div>
    )
}
export default Preiscrizioni_Nuoto